import {AppBar, Box} from "@mui/material";
import React from "react";
import {Logo} from "../Logo";
import {TopNav} from "./TopNav";

export function MinimalAppBar() {
	return (
		<AppBar
			elevation={0}
			position="static"
			color="inherit"
			sx={{
				borderBottom: 1,
				borderColor: "divider",
				backgroundColor: "paper.elevation1",
				color: "text.primary",
				displayPrint: "none",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexFlow: "row nowrap",
					justifyContent: "space-between",
					alignItems: "center",
					px: 2,
				}}
			>
				<Box sx={{py: 2}}>
					<Logo display="block" height={18} />
				</Box>
				<TopNav />
			</Box>
		</AppBar>
	);
}
